import { Product, Region, REGIONS } from '@boltenergy-be/shared'

/**
 * Utility to figure out the correct plenty promo context
 * @param {Product[]} products
 * @param {Region[]} regions
 * @returns {"singleProduct" | "multipleProducts" | "singleProduct+singleRegion" | "multipleProducts+singleRegion" | "singleProduct+multipleRegions" | "multipleProducts+multipleRegions"}
 */
export const getPromoContext = (
  products: Product[],
  regions: Region[]
):
  | 'singleProduct'
  | 'multipleProducts'
  | 'singleProduct+singleRegion'
  | 'multipleProducts+singleRegion'
  | 'singleProduct+multipleRegions'
  | 'multipleProducts+multipleRegions' => {
  const skipRegionText = !regions.length || regions.length === Object.keys(REGIONS).length
  const amountOfProducts = products.length

  if (skipRegionText) {
    return amountOfProducts === 1 ? 'singleProduct' : 'multipleProducts'
  }

  if (regions.length === 1) {
    return amountOfProducts === 1 ? 'singleProduct+singleRegion' : 'multipleProducts+singleRegion'
  }

  return amountOfProducts === 1 ? 'singleProduct+multipleRegions' : 'multipleProducts+multipleRegions'
}
